var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.breakpoint=='xs')?_c('IndexCompact',{attrs:{"customers":_vm.customers,"balances":_vm.balances,"drafts":_vm.drafts}}):_c('IndexNormal',{attrs:{"customers":_vm.customers,"balances":_vm.balances,"drafts":_vm.drafts}})
}
var staticRenderFns = []

export { render, staticRenderFns }